var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRectangleblue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "27px",
    viewBox: "0 0 36 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Rectangle 27") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Movil",
    stroke: "none",
    strokeWidth: 7,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ecommerce",
    transform: "translate(-1044.000000, -1464.000000)",
    stroke: "#004AD1",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Rectangle-27",
    transform: "translate(1062.000000, 1471.500000) rotate(-45.000000) translate(-1062.000000, -1471.500000) ",
    points: "1076 1479 1048 1479 1048 1464"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangleblue);
export default __webpack_public_path__ + "static/media/Rectangleblue.c3587b3e82659fca89b6d5c5e66e3b20.svg";
export { ForwardRef as ReactComponent };